import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import '../../gallery/components/GalleryItem.scss';
import {Tile as TileConfig} from './types';
import {getImageUrl, getObjectPosition} from "../../common/utils/imageUtils";

interface TileProps {
  tile: TileConfig;
}

const Tile: React.FC<TileProps> = ({tile}) => {
  const {t} = useTranslation();
  const colSpanClass = `col-span-${tile.width}`;
  const rowSpanClass = `row-span-${tile.height}`;
  const linkPath = tile.linkPath || `/gallery/artistic-object/${tile.id}`;

  const imageStyle = tile.focalPoint
    ? getObjectPosition(tile.focalPoint, tile.size)
    : {};

  return (
    <div className={`tile-item gallery-item bg-white rounded shadow-sm overflow-hidden ${colSpanClass} ${rowSpanClass}`}>
      <Link to={linkPath}
            className="tile-image-container block h-64 overflow-hidden relative flex justify-center bg-black group">
        <img
          className="w-full h-full object-cover"
          src={getImageUrl(tile.image)}
          alt={tile.title}
          style={imageStyle}
        />
        {tile.tag && (
          <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded-sm">
            {tile.tag}
          </div>
        )}
        <div className="tile-overlay absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-70 transition-all duration-300 flex flex-col justify-end p-4 opacity-0 group-hover:opacity-100">
          <div
            className="tile-description text-sm text-white line-clamp-3"
            dangerouslySetInnerHTML={{ __html: tile.description }}
          />
        </div>
      </Link>
      <div className="p-4">
        <h3 className="gallery-item-title font-medium text-gray-900">
          <Link to={linkPath} className="hover:text-gray-800 hover:underline">
            {tile.title}
          </Link>
        </h3>
        {tile.subtitle && (
          <p className="text-sm text-gray-600 mt-1">{tile.subtitle}</p>
        )}
        <div className="flex items-center mt-3">
          <Link
            to={linkPath}
            className="ml-auto bg-gray-800 hover:bg-black text-white text-xs px-3 py-1 rounded-sm"
          >
            {t('gallery.item.viewDetails')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Tile;

